import React from 'react';
import '../styles/ListHero.css';

const ListHero = () => (
	<div className="list__hero">
		<div className="list__hero-logo"></div>
		<p className="list__hero-text">launches 2018</p>
	</div>
);

export default ListHero;


// WEBPACK FOOTER //
// ./src/components/ListHero.js